export const checkConditionAndExecuteCallback = (condition, taskToExecute) => {
    if (condition) return taskToExecute();

    return null;
};
